<template>
  <div :class="{'cursor-pointer':item.deleted_at == null}" @dblclick="changeStatus()">
    <span class="status-chip" :class="statusState ? 'is-on' : 'is-off'">
      {{ statusState ? 'منتشر شده' : 'منتشر نشده' }}
    </span>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: {
    item: {
      default: null
    },
    itemType: {
      default: null
    }
  },
  name: "StatusChanger",
  computed: {
    statusState() {
      if (this.item && this.item.status == 1) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    changeStatus() {
      if (this.item.deleted_at == null) {
        const status = !this.item.status ? 1 : 0


        const form = {
          item_type: this.itemType,
          status: status,
          item_id: this.item.id
        }

        this.$store.dispatch('Content/changeStatus', form)
            .then((res) => {
              this.item.status = status
            })
            .catch((error) => {
              console.log(error);
            });
      }

    }
  }
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
  display: inline-block;
}

.status-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 28px;
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 800;
  line-height: 1.3;
  white-space: nowrap;
  width: max-content;
  max-width: none;
}

.status-chip.is-on {
  background: rgba(16, 185, 129, 0.16);
  color: #047857;
}

.status-chip.is-off {
  background: rgba(235, 61, 96, 0.14);
  color: #eb3d60;
}
</style>